<template>
  <div id="app">
    <keep-alive>
      <nfl-header></nfl-header>
    </keep-alive>
    <nflBanner style="padding-top: 20px;"></nflBanner>
    <router-view></router-view>
    <router-view name="latest"></router-view>
    <router-view name="newsFeed"></router-view>
    <nfl-adds-and-affiliate></nfl-adds-and-affiliate>
    <nfl-footer></nfl-footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Banner from "@/components/Banner";
import AddsAndAffiliate from "@/components/AddsAndAffiliate";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    nflHeader: Header,
    nflFooter: Footer,
    nflAddsAndAffiliate: AddsAndAffiliate,
    nflBanner: Banner
  },
  data: function() {
    return {};
  }
};
</script>

<style>
@import "./assets/css/style.css";
@import "./assets/css/responsive.css";

body {
  max-width: 99%;
}
</style>
